import { GetStaticProps, GetStaticPropsContext, NextPage } from 'next'

import { GetProps } from '~/utils/pageWrapper/types'

import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'

import { getStaticPage, getRunningQueriesThunk } from '~/redux/apis/static-page-api'
import SanityStaticPage from '~/static-pages/SanityStaticPage.page'
import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import appConfig from '~/config/app'

const PrivacyPage: NextPage = () => {
  return <SanityStaticPage />
}

const getProps: GetProps =
  (store) =>
  async ({ locale }: GetStaticPropsContext) => {
    store.dispatch(getStaticPage.initiate({ language: locale as string, path: '/privacy' }))
    await Promise.all(store.dispatch(getRunningQueriesThunk()))
    return {
      props: {
        namespaces: DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
      },
      revalidate: appConfig.isPublicWebsite ? 3600 : 60,
    }
  }

export const getStaticProps: GetStaticProps = getStaticPropsWrapper(getProps)

export default PrivacyPage
